import config from '../config'

const {avatarsStaticUrl} = config;

const DEFAULT_AVATAR = 'default.png';
const DEFAULT_AVATAR_SOURCE = `${avatarsStaticUrl}/assets/avatar/170x170/${DEFAULT_AVATAR}`;

export const getAvatarSource = (avatar) => {
  if (!avatar) {
    return DEFAULT_AVATAR_SOURCE;
  }
  
  return `${avatarsStaticUrl}/assets/avatar/170x170/${avatar}`;
}